import { CHANGELOG_AREAS, CHANGELOG_PLANS, CHANGELOG_TYPES } from '../../../components/changelog/changelogConfig';

/**
 * Rótulos e formatos do Admin Geral > Novidades (catálogo e envios).
 * Tipos, áreas e planos vêm do mesmo config da página Novidades.
 */

export const ITEM_STATUS = {
  draft: { label: 'Rascunho', color: '#B45309', bg: '#FFF4E5' },
  reviewed: { label: 'Revisado', color: '#5A80FB', bg: '#EEF2FF' },
  published: { label: 'Publicado', color: '#2E7D32', bg: '#E8F5E9' },
  internal: { label: 'Interno', color: '#64748B', bg: '#F1F5F9' },
  discarded: { label: 'Descartado', color: '#94A3B8', bg: '#F8FAFC' },
};

export const EDITION_STATUS = {
  draft: { label: 'Rascunho', color: '#B45309', bg: '#FFF4E5' },
  scheduled: { label: 'Agendado', color: '#5A80FB', bg: '#EEF2FF' },
  sending: { label: 'Enviando', color: '#7C3AED', bg: '#F3E8FF' },
  sent: { label: 'Enviado', color: '#2E7D32', bg: '#E8F5E9' },
  canceled: { label: 'Cancelado', color: '#64748B', bg: '#F1F5F9' },
};

export const AWAITING_DEPLOY = { label: 'Aguardando deploy', color: '#C62828', bg: '#FDECEA' };

export const EDITABLE_EDITION_STATUSES = ['draft', 'scheduled'];
export const isEditionEditable = (edition) => EDITABLE_EDITION_STATUSES.includes(edition?.status);

export const TYPE_OPTIONS = Object.entries(CHANGELOG_TYPES).map(([value, info]) => ({ value, label: info.label }));
export const AREA_OPTIONS = Object.entries(CHANGELOG_AREAS).map(([value, label]) => ({ value, label }));
export const PLAN_OPTIONS = Object.entries(CHANGELOG_PLANS).map(([value, info]) => ({ value, label: info.name }));

// Motivos de bloqueio devolvidos por item_status.php (texto livre também é aceito)
const BLOCK_REASONS = {
  awaiting_deploy: 'Aguardando deploy',
  missing_fields: 'Falta título, resumo ou área',
  missing_title: 'Falta o título',
  missing_summary: 'Falta o resumo',
  missing_area: 'Falta a área',
  internal: 'Item interno não sai em envio',
  not_reviewed: 'Ainda em rascunho: marque como revisado',
  discarded: 'Item descartado não sai em envio',
  published: 'Publicado: volte a rascunho antes de descartar',
  already_sent: 'Já saiu num envio: fica no histórico',
  not_found: 'Não encontrada',
};
export const blockReasonLabel = (reason) => BLOCK_REASONS[reason] || reason || 'Não foi possível mudar';

const parseDateTime = (value) => {
  if (!value) return null;
  const date = new Date(String(value).replace(' ', 'T'));
  return Number.isNaN(date.getTime()) ? null : date;
};

/** "10/10/26 09:00" */
export const formatDateTime = (value) => {
  const date = parseDateTime(value);
  if (!date) return value ? String(value) : '—';
  return date.toLocaleString('pt-BR', { dateStyle: 'short', timeStyle: 'short' });
};

/** "10/10/2026" a partir de "2026-10-10" (sem deslocamento de fuso) */
export const formatDate = (value) => {
  if (!value) return '—';
  const [year, month, day] = String(value).slice(0, 10).split('-');
  return year && month && day ? `${day}/${month}/${year}` : String(value);
};

/** "#3 · Semana 42" */
export const editionTitle = (edition) => {
  if (!edition) return '';
  const number = edition.number ? `#${edition.number}` : 'Envio';
  return edition.name ? `${number} · ${edition.name}` : number;
};
